export interface FactorSumProps {
  factor: any;
}
export default function FactorSum({ factor }: FactorSumProps) {
  const prices: any[] = [
    { label: "مبلغ", price: factor.total },
    { label: "تخفیف", price: factor.totalDiscount },
    { label: "مالیات", price: factor.totalTax },
    // { label: "هزینه حمل و نقل", price: factor.transferPrice },
    { divider: true },
    { label: "مجموع", price: factor.totalPrice },
  ];
  return (
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 12, minWidth: 200, padding: "12px 16px" }}>
        {prices.map((x,index) => {
          if (x.divider) {
            return <div key={index} style={{ borderTop: "1px solid #AEAEAE4D", margin: "12px 0px" }} />;
          } else
            return (
              <div style={{ display: "flex", justifyContent: "space-between", gap: 24 }}>
                <div style={{ fontSize: 12 }}>{x.label}</div>
                <div style={{ display: "flex", gap: 12 }}>
                  {/*<span style={{ fontSize: 11, color: "#AEAEAE" }}>{factor.Currency.en_title}</span>*/}
                  <span style={{ fontSize: 14 }}>{Intl.NumberFormat().format(x.price)}</span>
                </div>
              </div>
            );
        })}
      </div>
    </div>
  );
}
